const content  = {
    EN: {
      Name: 'Name',
      No: 'ID',
      Address: 'Address',
      City: 'City',
      Post_Code: 'Post Code',
      Phone_No: 'Phone No.',
      Orders: 'Outstanding Orders',
      Balance_LCY: 'Balance LCY',
      Net_Change_LCY: 'Net Change LCY',
      Currency_Code: 'Currency Code'
    },
    GR: {
        Name: 'Επωνυμία',
        No: 'ID',
        Address: 'Διεύθυνση',
        City: 'Πόλη',
        Post_Code: 'Τ.Κ.',
        Phone_No: 'Τηλ.',
        Orders: 'Εκκρεμείς Παραγγελίες',
        Balance_LCY: 'Υπόλοιπο',
        Net_Change_LCY: 'Κίνηση Περιόδου',
        Currency_Code: 'Νόμισμα'
    },
  };

  export default content;


// WEBPACK FOOTER //
// ./src/components/customerslist/content.js